// Phase B1: "restaurant" is the legacy name of the "business" role; both are accepted.
export const BUSINESS_ROLES = ['business', 'restaurant'];
export const isBusiness = (user) => BUSINESS_ROLES.includes(user?.role);
